import { refreshTokenApi } from "../api/HttpApis";
import { isImpersonating, endImpersonationLocally } from "./impersonation";

let refreshPromise = null;
let refresherId = null;

const interval = Number(process.env.REACT_APP_TOKEN_EXPIRY_TIME_INTERVAL); // ms

const refresh_before = Number(process.env.REACT_APP_TOKEN_REFRESH_BEFORE); // minutes

// One in-flight refresh shared by the interval below and the 401 interceptor
// in axiosInstance, so they never fire parallel refresh calls.
export const refreshSession = () => {
  if (!refreshPromise) {
    refreshPromise = refreshTokenApi().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
};

// Only a definitive rejection of the refresh token should end the session.
// Network errors, timeouts and 5xx (e.g. waking from sleep before the network
// is back) are transient: stay logged in and try again on the next tick/401.
export const isSessionRejected = (err) => {
  if (!localStorage.getItem("refreshToken")) return true;
  const status = err?.response?.status;
  return status === 401 || status === 403;
};

export const endSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("expireDate");
  localStorage.removeItem("userInfo");
  localStorage.removeItem("permissions");
  // Multi-tenant: drop the resolved tenant too, so the next login re-resolves
  // it from the hostname instead of reusing the previous tenant's id.
  localStorage.removeItem("tenantId");
  // localStorage.removeItem("role");
  // isGranted is deliberately left alongside "role" for the same reason: both
  // are re-written on every successful login, and this path is a session
  // expiry rather than a user switch. useLocalStoreClear (explicit logout)
  // does remove both.
  // localStorage.removeItem("isGranted");
  // Use hash for HashRouter - this will navigate without full page reload
  // If hash is already set, use replace to avoid adding to history
  if (window.location.hash) {
    window.location.replace("#/");
  } else {
    window.location.hash = "#/";
  }
};

export const checkTokenExpiry = async () => {
  const expireDate = parseInt(localStorage.getItem("expireDate"), 10);

  if (!expireDate) return null;

  const currentTime = Math.floor(Date.now() / 1000); // seconds
  const timeLeft = expireDate - currentTime; // seconds

  // Creator-portal sessions can't be refreshed (no refresh token); a failed
  // refresh below would clear the session, admin session stash included.
  // When it runs out, go back to the admin's own session instead.
  if (isImpersonating()) {
    if (timeLeft <= 0) endImpersonationLocally();
    return timeLeft;
  }

  //CONVERT minutes → seconds
  const refreshBeforeInSeconds = refresh_before * 60;

  // Also refresh an already-expired token (tab asleep past expiry): the
  // refresh token outlives it, so there's no need to wait for a 401.
  if (timeLeft <= refreshBeforeInSeconds) {
    try {
      await refreshSession();
    } catch (err) {
      if (isSessionRejected(err)) endSession();
    }
  }

  return timeLeft;
};

export const startTokenRefresher = () => {
  // Called from both axiosInstance and MainLayout; keep a single interval.
  if (refresherId || !localStorage.getItem("token")) return;
  refresherId = setInterval(checkTokenExpiry, interval);
};
